import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd01f254&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=dd01f254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd01f254",
  null
  
)

export default component.exports